<template>
   <section class="section-shaped my-5">
        <div class="shape">
            <span class="span-150"></span>
        </div>
    <div class="container">
            <div class="row">
                <div class="col-sm">
                        <img v-lazy="'img/brand/s9-dark.png'" alt="screeshoot"
                         class="img-fluid">
                </div>
                <div class="col-sm mt-5">
                    <h1>Download amazing stickers through Sticker Store.</h1>
                    <blockquote class="blockquote">
                     <p class="mb-0">Sticker Store for WhatsApp hosts the best collection of WhatsApp and Telegram stickers. Download just one app and get all stickers for WhatsApp and Telegram. </p>
                    </blockquote>
                    <div class="mx-auto mt-5">
                    <a href="https://play.google.com/store/apps/details?id=es.glstudio.wastickerapps" >
                    <base-button block type="primary">Download App</base-button>
                    </a>
                    </div>
                </div>
            </div>
        </div>
   </section>
</template>

<script>
export default {
  name: 'home'
}
</script>
